<template>
    <div></div>
</template>

<script>
import validator from "../../../core/validator.js";
import Gikam from "../../../core/gikam-core.js";
import Vue from "vue";

export default {
    data() {
        return {
            errorPanel: void 0,
            error: []
        };
    },

    methods: {
        getValidators() {
            const validators = [];
            if (!this.options.validators) {
                return validators;
            }
            this.options.validators.forEach(name => {
                let validator = {};
                if (name.indexOf("strLength") === 0) {
                    Gikam.extend(validator, {
                        type: "strLength",
                        rule: name.replace("strLength", "")
                    });
                } else if (name.indexOf("numRange") === 0) {
                    Gikam.extend(validator, {
                        type: "numRange",
                        rule: name.replace("numRange", "")
                    });
                } else if (name.indexOf("remote") === 0) {
                    return true;
                } else {
                    Gikam.extend(validator, {
                        type: name
                    });
                }
                validator.title = this.options.title;
                validators.push(validator);
            });
            return validators;
        },

        validate() {
            const validators = this.getValidators();
            const error = [];
            const _this = this;
            Gikam.each(validators, function() {
                let r = validator[this.type](
                    _this.value,
                    this.rule,
                    _this.field
                );
                if (r.result === false) {
                    error.push({
                        field: _this.field,
                        title: this.title,
                        message: r.message
                    });
                    return false;
                }
            });
            if (Gikam.isEmpty(error)) {
                return true;
            } else {
                this.error = error;
                return false;
            }
        },

        showErrorPanel(event) {
            const mountedDom = document.createElement("div");
            document.body.appendChild(mountedDom);
            const position = event.target.parentNode.parentNode.getBoundingClientRect();
            const top = position.top + position.height + 1;
            const left = position.left;
            this.errorPanel = new Vue({
                el: mountedDom,
                render: () => {
                    return (
                        <div
                            class="error-message-panel"
                            style={{
                                top: top + "px",
                                left: left + "px"
                            }}
                        >
                            {Gikam.propI18N(this.error[0].message)}
                        </div>
                    );
                }
            });
        },

        removeErrorPanel() {
            Gikam.removeDom(this.errorPanel.$el);
            this.errorPanel.$destroy();
        }
    }
};
</script>

<style scoped>
@keyframes fadeIn {
    from {
        opacity: 0.3;
    }
    to {
        opacity: 1;
    }
}

.error-message-panel {
    position: absolute;
    background-color: #666;
    width: 200px;
    height: 30px;
    border-radius: 4px;
    font-size: 12px;
    line-height: 30px;
    color: #fff;
    padding-left: 8px;
    animation: fadeIn 0.3s;
    z-index: 11;
}

.error-message-panel::before {
    content: "";
    display: block;
    position: absolute;
    width: 10px;
    height: 10px;
    background-color: #666;
    left: 10px;
    top: -2px;
    transform: rotate(45deg);
    border-radius: 2px;
}
</style>